import type { FormEvent } from 'react';

import { SearchableSelect } from '../../components/ui/SearchableSelect';
import { useInvestigationBillLookup } from '../investigation-bill/investigation-bill.queries';
import type { WorklistStatusOption } from './pathology.utils';
import type { WorklistFilters } from './types';

interface WorklistFilterBarProps<T extends WorklistFilters> {
  draft: T;
  onDraftChange: (updater: (current: T) => T) => void;
  onSubmit: (event: FormEvent) => void;
  onToday: () => void;
  onReset: () => void;
  busy: boolean;
  statusOptions?: WorklistStatusOption[] | undefined;
}

export const WorklistFilterBar = <T extends WorklistFilters>({ draft, onDraftChange, onSubmit, onToday, onReset, busy, statusOptions }: WorklistFilterBarProps<T>) => {
  const charges = useInvestigationBillLookup('charges');
  const selectedChargeIds = (draft.chargeIds ?? '').split(',').filter(Boolean);
  const chargeOptions = charges.data?.map((charge) => ({ value: charge.id, label: charge.label })) ?? [];

  const handleChargeChange = (values: string[]) => {
    onDraftChange((current) => ({ ...current, chargeIds: values.join(',') }));
  };

  return (
    <form className="investigation-bill-filter-grid pathology-filter-grid" onSubmit={onSubmit}>
      <select value={draft.field ?? ''} onChange={(event) => onDraftChange((current) => ({ ...current, field: event.target.value as WorklistFilters['field'], value: '' }))}>
        <option value="">SELECT FIELD</option><option value="patientName">PATIENT NAME</option><option value="uhid">UHID</option><option value="phone">Phone No</option>
      </select>
      <input value={draft.value ?? ''} onChange={(event) => onDraftChange((current) => ({ ...current, value: event.target.value }))} placeholder="Field Value" disabled={!draft.field} />
      {statusOptions ? (
        <select value={draft.status ?? statusOptions[0]?.value ?? 'all'} onChange={(event) => onDraftChange((current) => ({ ...current, status: event.target.value as WorklistFilters['status'] }))}>
          {statusOptions.map((option) => <option key={option.value} value={option.value}>{option.label}</option>)}
        </select>
      ) : null}
      <SearchableSelect
        multiple
        value={selectedChargeIds}
        options={chargeOptions}
        placeholder="Select tests"
        onChange={handleChargeChange}
        className="pathology-charge-filter"
        searchable
        clearable
      />
      <input type="date" value={draft.fromDate ?? ''} onChange={(event) => onDraftChange((current) => ({ ...current, fromDate: event.target.value }))} aria-label="From date" />
      <input type="date" value={draft.toDate ?? ''} onChange={(event) => onDraftChange((current) => ({ ...current, toDate: event.target.value }))} aria-label="To date" />
      <div className="investigation-bill-filter-actions"><button className="button button-primary" type="submit" disabled={busy}>Filter</button><button className="button investigation-bill-today" type="button" onClick={onToday}>Today</button><button className="button button-secondary" type="button" onClick={onReset}>Reset</button></div>
    </form>
  );
};